module.exports = __webpack_public_path__ + "img/logo-shiba888.d016d496.png";